import {
  Typography,
} from '@material-ui/core';
import {
  getIn,
  useFormikContext,
} from 'formik';
import React, {
  useEffect, useState,
} from 'react';
import ColorPicker from 'react-best-gradient-color-picker'

import FieldError from '../../Utils/FieldError';
import {
  FieldPropsCommon,
} from '../types';
import {
  onChange,
} from '../utils';

type Props<T, K extends keyof T> = FieldPropsCommon<T, K>;

const ColorField = <FormModel, FormModelKey extends keyof FormModel>(props: Props<FormModel, FormModelKey>) => {
  const {
    values,
    handleChange,
    errors,
    touched,
    isSubmitting,
    setFieldTouched,
  } = useFormikContext<FormModel>();

  const {
    disabled,
    title,
    location,
  } = props;

  const value: string = getIn(values, location);
  const onValueChange = onChange(handleChange, location);

  const error = getIn(errors, location);
  const isTouched = getIn(touched, location);

  useEffect(() => {
    if (isSubmitting) {
      setFieldTouched(location);
    }
  }, [isSubmitting, location, setFieldTouched]);

  if (!values) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        margin: 8,
      }}
    >
      <Typography
        variant="caption"
      >
        {title}
      </Typography>
      <div
        style={{
          width: '100%',
        }}
      >
        {
          !disabled && (
            <ColorPicker value={value} onChange={e => {
              setFieldTouched(location);
              onValueChange(e);
            }} hideColorTypeBtns={true} />


          )
        }
        {
          disabled && (
            <div
              style={{
                backgroundColor: value,
                width: 32,
                height: 32,
                borderRadius: 16,
              }}
            />
          )
        }
      </div>
      <FieldError
        errors={error}
        touched={isTouched}
      />
    </div>
  );
};

export default ColorField;
